var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPointEnclosedSurface(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE5\xAF\xBC\xE8\x88\xAA\xE5\x9B\xBE\xE6\xA0\x87"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1211",
    x: 6.5,
    y: 6.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "#222627"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 3",
    d: "M15 8L11.5 14.0622L4.5 14.0622L1 8L4.5 1.93782L11.5 1.93782L15 8Z",
    fill: "#00C2FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630572",
    x: 2.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "#222627"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630573",
    x: 10.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "#222627"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630574",
    x: 12.5,
    y: 6.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "#222627"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630575",
    x: 10.5,
    y: 12.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "#222627"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630576",
    x: 2.5,
    y: 12.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "#222627"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34630577",
    x: 0.5,
    y: 6.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "#222627"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointEnclosedSurface);
export default __webpack_public_path__ + "static/media/point-enclosed-surface.fe24a4bf127e24a52c3d52116fd116d4.svg";
export { ForwardRef as ReactComponent };